import { gql } from '@apollo/client';

export const DASHBOARD_CERTIFICATES_RECEIVED = gql`
  query CertificatesReceived($input: DashboardFilterArgs) {
    totalCertificatesReceived(input: $input)
    totalCertificatesReceivedChange(input: $input)
  }
`;
